import React from "react";
import useUI from "hooks/ui.hook";

import Basic_DaySelector from "./Basic/Components/DaySelector";
import Basic_MenuCard from "./Basic/Components/MenuCard";
import Basic_ModalReservation from "./Basic/Components/ModalReservation";
import Basic_ModalResume from "./Basic/Components/ModalResume";
import Basic_RepasComponent from "./Basic/Components/RepasComponent";
import Basic_CategorySelector from "./Basic/Components/CategorySelector";
import Basic_ModalInformations from "./Basic/Components/ModalInformations";
import Basic_DishCard from "./Basic/Components/DishCard";
import Basic_SupplementRestaurant from "./Basic/Components/SupplementRestaurant";
import Basic_GuestSelectorModal from "./Basic/Components/GuestSelectorModal";

import Heurus_ModalReservation from "./Specific/heurus/Components/ModalReservation";

import Ovelia_ModalReservation from "./Specific/ovelia/Components/ModalReservation";
import Ovelia_CategorySelector from "./Specific/ovelia/Components/CategorySelector";
import Ovelia_ModalInformations from "./Specific/ovelia/Components/ModalInformations";
import Ovelia_DishCard from "./Specific/ovelia/Components/DishCard";
import Ovelia_RepasComponent from "./Specific/ovelia/Components/RepasComponent";
import Ovelia_ModalResume from "./Specific/ovelia/Components/ModalResume";
import Ovelia_MenuCard from "./Specific/ovelia/Components/MenuCard";

import APIPROVENCE_RepasComponent from "./Specific/apiprovence/Components/RepasComponent";
import APIPROVENCE_ModalReservation from "./Specific/apiprovence/Components/ModalReservation";
import APIPROVENCE_CategorySelector from "./Specific/apiprovence/Components/CategorySelector";

import MarpaBergeDuLion_ModalReservation from "./Specific/marpaBergesDuLion/Components/ModalReservation";

import Aquarelia_ModalReservation from "./Specific/aquarelia/Components/ModalReservation";
import Aquarelia_ModalResume from "./Specific/aquarelia/Components/ModalResume";

import Migron_ModalReservation from "./Specific/migron/Components/ModalReservation";

import useFeature from "../../../hooks/useFeature";

import RALeoLagrange_MenuCard from "./Specific/leolagrange/Components/MenuCard";
import RALeoLagrange_CategorySelector from "./Specific/leolagrange/Components/CategorySelector";
import RALeoLagrange_ModalReservation from "./Specific/leolagrange/Components/ModalReservation";
import RALeoLagrange_ModalResume from "./Specific/leolagrange/Components/ModalResume";


export const CategorySelector = (props) => {
    const [ui] = useUI();
    if(ui.establishment.uid === "YOLKN6SwNZAOfBaFnAc7") return <RALeoLagrange_CategorySelector {...props} />;
    if (ui?.groupement?.specific === "ovelia") return <Ovelia_CategorySelector {...props} />;
    if (ui?.groupement?.specific === "apiprovence") return <APIPROVENCE_CategorySelector {...props} />;
    return <Basic_CategorySelector {...props} />;
};

export const ModalInformation = (props) => {
    const [ui] = useUI();

    if (ui?.groupement?.specific === "ovelia") return <Ovelia_ModalInformations {...props} />;
    return <Basic_ModalInformations {...props} />;
};

export const DishCard = (props) => {
    const [ui] = useUI();
    if (ui?.groupement?.specific === "ovelia") return <Ovelia_DishCard {...props} />;
    return <Basic_DishCard {...props} />;
};

export const DaySelector = (props) => {
    return <Basic_DaySelector {...props} />;
};

export const MenuCard = (props) => {
    const [ui] = useUI();
    if(ui.establishment.uid === "YOLKN6SwNZAOfBaFnAc7") return <RALeoLagrange_MenuCard {...props} />;
    if (ui?.groupement?.specific === "ovelia") return <Ovelia_MenuCard {...props} />;
    return <Basic_MenuCard {...props} />;
};

export const ModalReservation = (props) => {
    const [ui] = useUI();
    if(ui?.establishment?.uid === "PYEQkanUH1x8JFPJ2Knh") {
        // Suppression du portage
        return <Migron_ModalReservation {...props} />;
    }
    if(ui.establishment.uid === "YOLKN6SwNZAOfBaFnAc7") return <RALeoLagrange_ModalReservation {...props} />;
    if (ui?.groupement?.specific === "ovelia") return <Ovelia_ModalReservation {...props} />;
    if (ui?.establishment.uid === "Q1K3DO8mh4BO8AAI6SvM") return <MarpaBergeDuLion_ModalReservation {...props} />;
    if (ui?.groupement?.specific === "apiprovence") return <APIPROVENCE_ModalReservation {...props} />;
    if (ui?.groupement?.specific === "heurus") return <Heurus_ModalReservation {...props} />;
    if (ui?.groupement?.specific === "aquarelia") return <Aquarelia_ModalReservation {...props} />;
    return <Basic_ModalReservation {...props} />;
};

export const ModalResume = (props) => {
    const [ui] = useUI();
    if(ui.establishment.uid === "YOLKN6SwNZAOfBaFnAc7") return <RALeoLagrange_ModalResume {...props} />;
    if (ui?.groupement?.specific === "ovelia") return <Ovelia_ModalResume {...props} />;
    if (ui?.groupement?.specific === "aquarelia") return <Aquarelia_ModalResume {...props} />;
    return <Basic_ModalResume {...props} />;
};

export const RepasComponent = (props) => {
    const [ui] = useUI();

    if (ui?.groupement?.specific === "ovelia") return <Ovelia_RepasComponent {...props} />;
    if (ui?.groupement?.specific === "apiprovence") return <APIPROVENCE_RepasComponent {...props} />;
    return <Basic_RepasComponent {...props} />;
};

export const SupplementRestaurant = (props) => {
    const [ui] = useUI();
    if(!useFeature("restaurant")) return <></>;

    return <Basic_SupplementRestaurant {...props} />;
};

export const GuestSelectorModal = (props) => {
    return <Basic_GuestSelectorModal {...props} />;
}
